import request from '@/lib/request';
import router from '@/router';

let uuid = '';
let documentReferrer = sessionStorage.getItem('first_visited_referrer');
if (!documentReferrer) {
  if (document.referrer) {
    documentReferrer = decodeURIComponent(document.referrer);
  } else {
    documentReferrer = 'none';
  }
  sessionStorage.setItem('first_visited_referrer', documentReferrer);
}

function fetchUuid() {
  if (uuid) {
    return uuid;
  } else {
    uuid = localStorage.getItem('log_uuid');
    return uuid || '';
  }
}

export function handleLog({ toPathName, apiUrl, operateName, otherParams = undefined }) {
  const [fromPath, fromQuery] = window.location.href.split('#')[1].split('?');
  const routeArr = router.getRoutes();
  const toRouteInfo = toPathName ? routeArr.find(routeItem => routeItem.name === toPathName) : null;
  const toPath = toRouteInfo ? toRouteInfo.path : '';

  return request.post('/admin/page/collection', {
    uuid: fetchUuid(),
    fromPath,
    fromQuery,
    from: { path: documentReferrer, query: {} },
    toPath,
    method: 'POST',
    interfaceName: apiUrl,
    operateName,
    source: '实证分析',
    ...(otherParams || {})
  });
}

export function routerLog(params) {
  return request.post('/admin/page/collection', {
    ...params,
    uuid: fetchUuid(),
    method: 'POST',
    source: '路由跳转frontend-evidence'
  });
}
